import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Button } from '../components';

const baseStyles = () => css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  text-align: right;
`;

const submittedStyles = ({ theme, isSubmitted }) =>
  isSubmitted &&
  css`
    margin-bottom: 0;
    padding: 0 ${theme.spacings.mega};
  `;

const Container = styled('div')(baseStyles, submittedStyles);

const buttonContainerBaseStyles = ({ theme }) =>
  css`
    width: 100%;
    padding: 0 ${theme.spacings.zetta};
  `;

const ButtonContainer = styled('div')(buttonContainerBaseStyles);

const SubmitQuiz = ({ text, isSubmitting, selected, onSubmit, disabled, ...props }) => (
  <Container>
    <ButtonContainer>
      <Button
        type='submit'
        variant='primary'
        isSubmitting={isSubmitting}
        onSelect={() => onSubmit(selected)}
        disabled={disabled}
        stretch
        {...props}
      >
        {text}
      </Button>
    </ButtonContainer>
  </Container>
);

SubmitQuiz.propTypes = {
  text: PropTypes.string,
  isSubmitting: PropTypes.bool,
  selected: PropTypes.string,
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
};

SubmitQuiz.defaultProps = {
  text: 'Submit Answer',
  disabled: true,
};

export default SubmitQuiz;
